<template>
  <div class="absolute -left-8 ml-2 flex hover:w-full">
    <InfoRoundedSmall class="peer h-5 w-5 text-zuno-turquoise" />
    <div
      role="tooltip"
      class="absolute left-6 z-10 hidden w-full max-w-fit rounded-md border border-gray-200 bg-white p-2 text-sm font-medium text-gray-900 shadow-sm peer-hover:inline-block"
    >
      {{ tooltipText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolTip',

  props: {
    tooltipText: {
      type: String,
      default: 'Tooltip content',
    },
  },
}
</script>
